import { FC } from "react";
import { ShareIssueModel } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { VBox } from "@/components-v2/Box";
import NewShareType from "./NewShareType";
import ShareIssueForShareType, { ShareIssueForShareType2 } from "./ShareIssueForShareType";
import { MCheckboxGroup } from "@/components-v2/Checkbox";
import { useTranslation } from "@/stores/RootStoreContext";
import { findShareTypeName } from "@/common/share";

export const SelectShareTypesForIssue2 = observer(
  ({
    model,
    disableIndividualSharePrice,
  }: {
    model: ShareIssueModel;
    disableIndividualSharePrice: boolean;
  }) => {
    const { t, lang } = useTranslation();
    return (
      <VBox>
        <div>{t("decisions.increaseShareCapitalAgainstCash.selectShareType2")}</div>
        <MCheckboxGroup
          model={model.selectedShareTypes}
          onChange={(_event, option) => model.toggleSelectedShareType(option)}
          disabled={model.isProjectLocked}
          labelFn={(item) => findShareTypeName(item.shareType, lang)}
          extraContentFn={(item, checked) =>
            checked && (
              <VBox marginTop={"md"} marginBottom={"lg"} gap={"md"}>
                <ShareIssueForShareType2
                  model={item.model}
                  isLocked={model.isProjectLocked}
                  disableIndividualSharePrice={disableIndividualSharePrice}
                />
              </VBox>
            )
          }
        />
        <NewShareType model={model} />
      </VBox>
    );
  },
);

const SelectShareTypesForIssue: FC<{
  model: ShareIssueModel;
  disableIndividualSharePrice: boolean;
}> = observer(({ model, disableIndividualSharePrice }) => {
  const { t, lang } = useTranslation();
  return (
    <>
      <VBox>
        <div>{t("decisions.increaseShareCapitalAgainstCash.selectShareType")}</div>
        <MCheckboxGroup
          model={model.selectedShareTypes}
          onChange={(_event, option) => model.toggleSelectedShareType(option)}
          disabled={model.isProjectLocked}
          labelFn={(item) => findShareTypeName(item.shareType, lang)}
        />
        <NewShareType model={model} />
      </VBox>
      {model.selectedShareTypes.selected.map((m) => (
        <ShareIssueForShareType
          model={m.model}
          isLocked={model.isProjectLocked}
          key={m.sharetypeId}
          disableIndividualSharePrice={disableIndividualSharePrice}
        />
      ))}
    </>
  );
});

export default SelectShareTypesForIssue;
